import React, { useState } from 'react';
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { useTranslation } from 'react-i18next';
import { updateSelectedResource, updateUnSelectedResource, updateAllSelectedAndUnSelected, selectedAndUnSelectedOnEditMode, searchProjectTeam } from "../../project/projectSlice";
import { getValueFromResource } from '../../../common/timeLiveFunction';
const ProjectResource = (props: any) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [selectAll, setSelectAll] = useState<boolean>(false);
    const [searchProjectsTeam, setSearchProjectTeam] = useState('');
    const { projectTeamList, accountprojectid } = useAppSelector((state) => state.project);
    const { isShowEmployeeNameWithCode, showEmployeeNameBy } = useAppSelector((state) => state.globalState);
    
    const selectUnSelect = (isSelect: boolean) => {
        if (accountprojectid != 0) {
            dispatch(selectedAndUnSelectedOnEditMode(isSelect));
        } else {
            const newState = projectTeamList.map((obj: any) => {
                return { ...obj, IncludeTeam: isSelect ? 1 : 0 };
            });
            dispatch(updateAllSelectedAndUnSelected(newState));
        }
    }

    const onSwitchCheckAll = (data: any) => {
        selectAll ? setSelectAll(false) : setSelectAll(true);
        data.target.checked ? selectUnSelect(true) : selectUnSelect(false);
    }

    // const onHandleSearch = (event: any) => {
    //     const { value } = event.target;
    //     setSearchProjectTeam(value);
    //     dispatch(searchProjectTeam(value));
    // }

    const onHandleSearch = (event: any) => {
        const { value } = event.target;
        setSearchProjectTeam(value);
        dispatch(searchProjectTeam(value));
        if (value.trim() === '') {
            dispatch(searchProjectTeam(''));
        }
    };

    function getFullName(item: any) {
        /* const { IsShowEmployeeNameWithCode, ShowEmployeeNameBy } = accountPreferences; */
        const { EmployeeCode, FirstName, LastName, IsDisabled } = item;
    
        // Employee code logic
        const employeeCodePrefix = isShowEmployeeNameWithCode && EmployeeCode ? `${EmployeeCode} - ` : '';
    
        // Full name based on ShowEmployeeNameBy and IsDisabled
        if (showEmployeeNameBy === 2 && IsDisabled) {
            return `${employeeCodePrefix}${LastName} ${FirstName} (Disabled)`;
        } else if (showEmployeeNameBy === 2 && !IsDisabled) {
            return `${employeeCodePrefix}${LastName} ${FirstName}`;
        } else if (showEmployeeNameBy === 1 && IsDisabled) {
            return `${employeeCodePrefix}${FirstName} ${LastName} (Disabled)`;
        } else {
            return `${employeeCodePrefix}${FirstName} ${LastName}`;
        }
    }   

    return (
        <>
            <div className='row selectAllDiv'>
                <div className="col-md-6">
                    <div className="wrapper" style={{ marginLeft: -10 }}>
                        <input
                            type="text"
                            value={searchProjectsTeam}
                            onChange={onHandleSearch}
                            placeholder=
                            // {t('Search')}
                            {getValueFromResource('Search',dispatch, t)}
                            className="form-control h-35px w-225px fs-7 fw-normal mb-2"
                        />
                        <i className="insideField-Search-Icons ki-outline ki-magnifier text-gray"></i>
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className="form-check form-switch form-check-custom form-check-solid me-0" style={{ justifyContent: 'flex-end', marginBottom: 10 }}>
                        <input
                            className="form-check-input h-20px w-30px me-2"
                            type='checkbox'
                            name='CheckAll'
                            checked={selectAll}
                            onChange={(e) => { onSwitchCheckAll(e) }}
                        />
                        <span className='form-label fs-7 fw-normal mt-2'>
                            {/* {t('Select All')} */}
                            {getValueFromResource('Select All',dispatch, t)}
                            </span>
                    </div>
                </div>
            </div>
            {/* <div className='row selectAllDiv'>
                <div className="form-check form-switch form-check-custom form-check-solid me-10" style={{ justifyContent: 'flex-end', marginBottom: 10 }}>
                    <input
                        className="form-check-input h-20px w-30px me-2"
                        type='checkbox'
                        name='CheckAll'
                        checked={selectAll}
                        onChange={(e) => { onSwitchCheckAll(e) }}
                    />
                    <span className='form-label fs-7 fw-normal mt-2'>{t(`Select All`)}</span>
                </div>
            </div> */}
            <div className="table-responsive">
                <table className='table table-row-bordered table-bottom-color align-middle gs-2 gy-3 gx-0'>
                    <thead>
                        <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                            <th style={{ width: 72 }}></th>
                            <th>
                                {/* {t("Employee Name")} */}
                                {getValueFromResource('Employee Name',dispatch, t)}
                                </th>
                        </tr>
                    </thead>
                    <tbody>
                        {projectTeamList && projectTeamList.map((item: any, index: any) => {
                            return (
                                <tr key={item.AccountEmployeeId}>
                                    <td>
                                        {item.IncludeTeam == 0 ?
                                            <div className='symbol symbol-circle symbol-35px cursor'
                                                onClick={() => dispatch(updateSelectedResource({ AccountEmployeeId: item.AccountEmployeeId, AccountProjectEmployeeId: item.AccountProjectEmployeeId }))}>
                                                <div className='symbol-label fw-bold'
                                                    style={{ backgroundColor: item.ProfilePictureColor != '' ? item.ProfilePictureColor : '#512da8', color: '#fff', marginRight: 8 }}>
                                                    {`${item.FirstName.charAt(0).toUpperCase()}${item.LastName.charAt(0).toUpperCase()}`}
                                                    
                                                    </div>
                                            </div> :
                                            <div className='symbol symbol-circle symbol-35px cursor'
                                                onClick={() => dispatch(updateUnSelectedResource({ AccountEmployeeId: item.AccountEmployeeId, AccountProjectEmployeeId: item.AccountProjectEmployeeId }))}>
                                                <div className="symbol symbol-35px me-2">
                                                    <span className="symbol-label bg-light-primary">
                                                        <i className="ki-outline ki-check-circle text-primary fs-1"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        }
                                    </td>
                                    <td>
                                        <span className='cursor' onClick={() => {
                                            item.IncludeTeam == 0 ?
                                                dispatch(updateSelectedResource({ AccountEmployeeId: item.AccountEmployeeId, AccountProjectEmployeeId: item.AccountProjectEmployeeId })) :
                                                dispatch(updateUnSelectedResource({ AccountEmployeeId: item.AccountEmployeeId, AccountProjectEmployeeId: item.AccountProjectEmployeeId }))
                                        }}>
                                            {/* {`${item.FirstName} ${item.LastName}`} */}
                                            {getFullName(item)}
                                            </span>
                                    </td>
                                </tr>)
                        })}
                    </tbody>
                </table>
                {projectTeamList.length === 0 &&
                    <div className=''>
                        <p className='noDataFound'>
                            {/* {t('No Record Found')} */}
                            {getValueFromResource('No Record Found',dispatch, t)}
                            </p>
                    </div>
                }
            </div>
        </>
    )
}

export default ProjectResource;